<div class="report-model">
    <div class="report-model-header">
        <div class="info">
            <h3>{{"reports.theSupplyOfResidentialLands" | translate}} {{houseVillaChart.length ? houseVillaChart.length
                :''}} {{'reports.years'| translate}}</h3>
        </div>
    </div>
    <ng-container *ngIf="houseVillaChartLoading">
        <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
    </ng-container>
    <ng-container *ngIf="!houseVillaChartLoading">
        <app-report-charts [data]="houseVillaChart" [chartType]="chartView.barChart"
            [name]="'houseVillasbarChart'"></app-report-charts>
    </ng-container>
</div>